import type { PluginManifest } from "@d12labs/plugins/types";

export const manifest: PluginManifest = {
	name: "kb",
	label: "Knowledge Base",
	description:
		"Project Knowledge Base — upload documents, embed them, and ask grounded questions (RAG).",
	version: "0.1.0",
	navItems: [{ label: "Knowledge Base", href: "/kb", icon: "Library" }],
};
